import React from 'react';
import { Table, Radio } from 'antd';
import { AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';

const DataTable = ({ 
  data, 
  columns, 
  viewMode, 
  onViewModeChange, 
  renderCard, 
  loading = false,
  showViewToggle = true,
  tableProps = {},
  gridProps = {}
}) => {
  const defaultTableProps = {
    pagination: { 
      pageSize: 10,
      showSizeChanger: true,
      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
      responsive: true,
      showQuickJumper: true
    },
    scroll: { x: 1000 },
    size: 'middle',
    ...tableProps
  };

  const defaultGridProps = {
    style: { 
      display: 'grid', 
      gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', 
      gap: '16px',
      maxHeight: '600px',
      overflowY: 'auto',
      padding: '4px'
    },
    ...gridProps
  };

  return (
    <>
      {showViewToggle && (
        <div style={{ 
          marginBottom: '16px',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}>
          <Radio.Group 
            value={viewMode} 
            onChange={(e) => onViewModeChange?.(e.target.value)}
            buttonStyle="solid"
            size="middle"
          >
            <Radio.Button value="table">
              <UnorderedListOutlined />
              <span className="view-toggle-text">Table</span>
            </Radio.Button>
            <Radio.Button value="grid">
              <AppstoreOutlined />
              <span className="view-toggle-text">Grid</span>
            </Radio.Button>
          </Radio.Group>
        </div>
      )}

      {viewMode === 'table' ? (
        <Table 
          columns={columns}
          dataSource={data}
          loading={loading}
          {...defaultTableProps}
        />
      ) : (
        <div {...defaultGridProps}>
          {data.map((item, index) => renderCard?.(item, index))}
        </div>
      )}
    </>
  );
};

export default DataTable;
